module.exports = __webpack_public_path__ + "img/点变家-05.f7b0eb8b.png";